import styled from 'styled-components'
import { colors } from 'app/theme/colors'

export const Wrapper = styled.div`
  color: ${colors.ohDarkOrange};
`
